const COOKIES = {
  IS_USER_LOGGED: 'is_user_logged',
};

export default COOKIES;
